import { IRegionalParams, IRegional } from "src/@types/regional";
import { Paginated } from "src/@types/paginated";
import { Tags } from "../../src/enum/tags";
import { apiSlice } from "./http";

export const RegionalInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRegionals: builder.query<Paginated<IRegional>, IRegionalParams>({
      query: ({ search, meta, orderBy, status, perPage }) => {
        const params = new URLSearchParams({
          search: search ?? "",
          orderBy:
            typeof orderBy === "string"
              ? orderBy
              : JSON.stringify(orderBy ?? { id: "asc" }),
          page: meta.page.toString(),
          perPage: (perPage ?? 15).toString(),
        });

        if (status && status !== "ALL") {
          params.set("status", status);
        }

        return {
          url: `/regional?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.REGIONAL],
    }),

    deactivateRegional: builder.mutation<
      {
        success: boolean;
        message: string;
        data: {
          regional: any;
          unlinked_stores: Array<{ code: number; name: string }>;
          unlinked_count: number;
        };
      },
      number
    >({
      query: (id) => ({
        url: `/regional/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [Tags.REGIONAL],
    }),

    reactivateRegional: builder.mutation<void, number>({
      query: (id) => ({
        url: `/regional/${id}/reactivate`,
        method: "PATCH",
      }),
      invalidatesTags: [Tags.REGIONAL],
    }),

    updateRegional: builder.mutation<
      IRegional,
      { id: number; name: string; email: string }
    >({
      query: ({ id, name, email }) => ({
        url: `/store/regional/${id}`,
        method: "PUT",
        body: { name, email },
      }),
      invalidatesTags: [Tags.REGIONAL],
    }),
    addRegional: builder.mutation<void, string[]>({
      query: (names) => ({
        url: `/store/regional/add`,
        method: "POST",
        body: names,
      }),
      invalidatesTags: [Tags.OPTIONS_REGIONAL, Tags.REGIONAL],
    }),
    addOneRegional: builder.mutation<void, { name: string }>({
      query: (data) => ({
        url: `/store/regional/add`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [Tags.OPTIONS_REGIONAL, Tags.REGIONAL],
    }),
  }),

  overrideExisting: true,
});

export const {
  useGetRegionalsQuery,
  useDeactivateRegionalMutation,
  useReactivateRegionalMutation,
  useUpdateRegionalMutation,
  useAddOneRegionalMutation,
  useAddRegionalMutation,
} = RegionalInformations;

export const {
  endpoints: {
    getRegionals: { select: selectGetStores },
    deactivateRegional: { select: deactivateRegional },
    reactivateRegional: { select: reactivateRegional },
    updateRegional: { select: updateRegional },
    addOneRegional: { select: addOneRegional },
    addRegional: { select: addRegional },
  },
} = RegionalInformations;
